import { render, staticRenderFns } from "./UpdateInsuranceStatusModal.vue?vue&type=template&id=3072740c"
import script from "./UpdateInsuranceStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateInsuranceStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports